export default __webpack_public_path__ + "static/media/icon-doctor-avatar-dashboard.c42d953b.svg";